/* eslint-disable @typescript-eslint/no-explicit-any */
import { captureException, captureMessage } from "@sentry/react";

enum LoggerLevels {
    crit = 0,
    error = 1,
    warning = 2,
    log = 3,
    debug = 4,
}

class Logger {
    private readonly currentLevel: LoggerLevels;

    constructor() {
        this.currentLevel = process.env.NODE_ENV === "production" ? LoggerLevels.log : LoggerLevels.debug;
    }

    private shouldLog(level: LoggerLevels): boolean {
        return level <= this.currentLevel;
    }

    protected sendErrorToSentry(error: Error) {
        captureException(error);
    }

    protected sendMessageToSentry(...message: any) {
        captureMessage(JSON.stringify(message));
    }

    // arrow properties: the public methods get passed as callbacks (`.catch(logger.error)`) and must stay bound
    public crit = (error: Error, ...rest: any) => {
        if (this.shouldLog(LoggerLevels.crit)) {
            console.error(...rest, error);
            this.sendErrorToSentry(error);
        }
    };

    public error = (...message: any): void => {
        if (this.shouldLog(LoggerLevels.error)) {
            console.error(...message);
        }
    };

    public warning = (...message: any): void => {
        if (this.shouldLog(LoggerLevels.warning)) {
            console.warn(...message);
        }
    };

    public logToSentry = (...message: any): void => {
        if (this.shouldLog(LoggerLevels.log)) {
            console.log(...message);
            this.sendMessageToSentry(...message);
        }
    };

    public log = (...message: any): void => {
        if (this.shouldLog(LoggerLevels.log)) {
            console.log(...message);
        }
    };

    public debug = (...message: any): void => {
        if (this.shouldLog(LoggerLevels.debug)) {
            console.log(...message);
        }
    };
}

export const logger = new Logger();
